import React from 'react';

import styles from './loader.module.scss';

function Loader() {
  return <div className={styles.loader} />;
}

export default Loader;
